module.exports = __webpack_public_path__ + "static/EMM_1-28f080529446d82edb8ee1d8af48d29e.png";